import oneTimeLiveLessonMutation from '../mutations/OneTimeLiveLesson.gql'

export default function (variables) {
  return {
    mutation: oneTimeLiveLessonMutation,
    variables: variables,
  }
}
